export default __webpack_public_path__ + "static/media/gallery_08.1aa2a887.jpg";